import { call, put, select } from 'redux-saga/effects';
import moment from 'moment';
import UserClient from '../../api/UserClient';
import { messagesShow } from '../../redux/messages/actions';
import { subscriptionIdSelector, profileIdSelector, mobilityPlansSelector } from '../../selectors/user';
import { setSubscriptions, setSubscriptionsUpdating } from '../../redux/user/actions';

export default function* switchPlan({ payload }) {
    const { callback, planId, successMessage } = payload;

    try {
        yield put(setSubscriptionsUpdating(true));

        const subscriptionId = yield select(subscriptionIdSelector);
        const profileId = yield select(profileIdSelector);
        const oldSubscription = yield call(UserClient.unsubscribeFromAPlan, { subscriptionId, profileId });

        const newSubscription = yield call(UserClient.subscribeToAPlan, { planId, profileId });
        const plans = yield select(mobilityPlansSelector);

        const newPlan = plans.find(plan => plan.id === newSubscription.planId) || {};
        yield put(
            messagesShow(
                successMessage
                    .replace('{newPlan}', newPlan.name || '')
                    .replace('{endDate}', moment(oldSubscription.expiryDate).format('M/DD/YYYY')),
                'success'
            )
        );

        yield put(setSubscriptions([oldSubscription]));
    } catch (error) {
        yield put(messagesShow(error, 'error'));
        console.error('[unsubscribeFromAPlan]', error);
    } finally {
        yield put(setSubscriptionsUpdating(false));

        if (callback) {
            callback();
        }
    }
}
